import { useEffect, useState } from "react";
import { http } from "../../lib/api";
import { Card } from "../kit/Kit";
import { mxn } from "./common";
import { fDia } from "../../lib/trading";

const pct = (v) => (v == null ? "—" : `${v.toFixed(2)}%`);
const ET = { en_tabla: "En tabla", fuera: "Fuera de tabla", sin_tabla: "Sin tabla vigente" };

export const CapCampana = () => {
  const [d, setD] = useState(null);
  useEffect(() => { http.get("/captacion/campana/resumen").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (!d) return null;
  return (
    <Card title={`Resumen de campaña · v${d.version} ${d.nombre}`} subtitle={`Vigencia ${fDia(d.desde, true)} → ${fDia(d.hasta, true)} · corte ${fDia(d.corte, true)}`} testid="cap-campana">
      <div className="grid grid-cols-2 gap-3 text-sm md:grid-cols-5">
        <p data-testid="cap-campana-contratos"><span className="block text-xs text-[#8C867A]">Contratos en vigencia</span>{d.contratos} · {mxn(d.saldo)}</p>
        {Object.entries(d.estados).map(([k, v]) => <p key={k} data-testid={`cap-campana-${k}`}><span className="block text-xs text-[#8C867A]">{ET[k]}</span>{v.contratos} · {mxn(v.saldo)}</p>)}
        <p data-testid="cap-campana-tasa"><span className="block text-xs text-[#8C867A]">Tasa ponderada vs tabla</span>{pct(d.tasa_ponderada)} vs {pct(d.tasa_tabla_ponderada)}</p>
      </div>
      <div className="mt-3 overflow-x-auto"><table className="w-full min-w-[420px] text-xs" data-testid="cap-campana-plazos">
        <thead><tr className="text-left text-[#8C867A]"><th className="py-1">Plazo</th><th>Contratos</th><th>Saldo</th><th>Tasa pond.</th><th>Tabla</th><th>En / fuera / sin</th></tr></thead>
        <tbody>{d.por_plazo.map((p) => <tr key={p.plazo} className="border-t border-[#F2F0EC]"><td className="py-1">{p.plazo}</td><td>{p.contratos}</td><td>{mxn(p.saldo)}</td><td>{pct(p.tasa_ponderada)}</td><td>{pct(p.tasa_tabla)}</td><td>{p.en_tabla} / {p.fuera} / {p.sin_tabla}</td></tr>)}</tbody>
      </table></div>
      <p className="mt-2 text-[11px] text-[#8C867A]">{d.como}</p>
    </Card>
  );
};
